import React from 'react';
import PropTypes from 'prop-types';

import styles from './RouteLayout.module.css';

const RouteLayout = ({ title, titleExtra, children }) => {
    return (
        <div className={styles.container}>
            <div className={styles.title}>
                { title }
                { titleExtra }
            </div>

            { children }
        </div>
    );
};

RouteLayout.propTypes = {
    title: PropTypes.string,
    titleExtra: PropTypes.node,
};

export default RouteLayout;